(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const loadRecaptcha = (siteKey) => {
    if (!siteKey || window.grecaptchaLoaded) return;
    window.grecaptchaLoaded = true;
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  };
  const getRecaptchaToken = (siteKey) =>
    new Promise((resolve) => {
      if (!siteKey || typeof grecaptcha === 'undefined') return resolve(null);
      grecaptcha.ready(() => {
        grecaptcha
          .execute(siteKey, { action: 'email_signup' })
          .then(resolve)
          .catch((err) => {
            console.warn('reCAPTCHA token error:', err.message);
            resolve(null);
          });
      });
    });

  const init = (root = document) => {
    root.querySelectorAll('[data-email-signup]').forEach((block) => {
      const form = block.querySelector('form');
      if (!form || form.dataset.klaviyoSignupBound === 'true') return;
      form.dataset.klaviyoSignupBound = 'true';

      const { recaptchaSiteKey, successMessage } = block.dataset;
      loadRecaptcha(recaptchaSiteKey);

      const button = form.querySelector('button[type="submit"]');
      const emailInput = form.querySelector('input[type="email"]');
      const nameInput = form.querySelector('input[name="$first_name"]');
      const honeypotInput = form.querySelector('input[name="website"]');
      const messageEl = form.querySelector('.email-signup-block__message');
      const listId = form.querySelector('input[name="g"]')?.value;

      const showMessage = (text, role = 'alert') => {
        if (!messageEl) return;
        messageEl.textContent = text;
        messageEl.setAttribute('role', role);
        messageEl.style.display = 'block';
      };

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // silently reject honeypot-filled submissions (bots)
        if (honeypotInput?.value.trim()) {
          showMessage(successMessage || 'Thanks for signing up!', 'status');
          form.reset();
          return;
        }

        if (button) button.disabled = true;
        if (messageEl) messageEl.style.display = 'none';

        const email = emailInput?.value.trim() ?? '';
        const name = nameInput?.value.trim() ?? '';

        if (!email || !listId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showMessage('Please enter a valid email address.');
          if (button) button.disabled = false;
          return;
        }

        const token = await getRecaptchaToken(recaptchaSiteKey);

        const formData = new FormData();
        formData.append('email', email);
        formData.append('g', listId);
        if (name) formData.append('$first_name', name);
        if (token) formData.append('g-recaptcha-response', token);

        try {
          const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) throw new Error('Subscription failed');

          showMessage(successMessage || 'Thanks for signing up!', 'status');
          if (emailInput) emailInput.disabled = true;
          if (nameInput) nameInput.disabled = true;
          if (button) button.style.display = 'none';
        } catch {
          showMessage('Something went wrong. Please try again.');
          if (button) button.disabled = false;
        }
      });

      emailInput?.addEventListener('input', () => {
        if (button) button.disabled = false;
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', ({ target }) => init(target));
  document.addEventListener('shopify:block:select', ({ target }) => init(target));
})();
  } catch(e) { console.error(e); }
})();

})();
